import React from "react";
import Title from "../../Add/title";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {ability} from "../../../../config/acl/ability";

const MainDetails = ({
  handleChange,
  formData,
  countries,
  currencies,
  handleCoursesChange,
}) => {
    const canEditPanelUrl = ability.can('panel_url','update')
  return (
    <div className="main-details">
      <Title title="Main Details" />
      <FormControl fullWidth size="small">
        <InputLabel>Service Type</InputLabel>
        <Select
          value={formData.reading_type || "HTML"}
          label="Service Type"
          onChange={(e) => handleChange("reading_type", e.target.value)}
        >
          <MenuItem value="HTML">HTML</MenuItem>
          <MenuItem value="API">API</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Panel name"
        fullWidth
        variant="outlined"
        onChange={(e) => {
          handleChange("smmpanel_name", e.target.value);
        }}
        name="smmpanel_name"
        value={formData?.smmpanel_name}
        size="small"
        disabled={canEditPanelUrl ? false :true}
      />
      <TextField
        fullWidth
        variant="outlined"
        label="Panel Url"
        onChange={(e) => {
          handleChange("smmpanel_url", e.target.value);
        }}
        name="smmpanel_url"
        value={formData?.smmpanel_url}
        size="small"
        type="url"
        disabled={canEditPanelUrl ? false :true}
      />
      {/*{formData.reading_type === "HTML" && (*/}
        <>
          <TextField
            label="Login user"
            fullWidth
            variant="outlined"
            value={formData?.smmpanel_loginuser}
            onChange={(e) => handleChange("smmpanel_loginuser", e.target.value)}
            name="smmpanel_loginuser"
            size="small"
          />
          <TextField
            label="Login username"
            fullWidth
            variant="outlined"
            value={formData?.smmpanel_loginusername}
            onChange={(e) => handleChange("smmpanel_loginusername", e.target.value)}
            name="smmpanel_loginusername"
            size="small"
          />
          <TextField
            label="Login password"
            fullWidth
            variant="outlined"
            value={formData?.smmpanel_login_password}
            onChange={(e) =>
              handleChange("smmpanel_login_password", e.target.value)
            }
            name="smmpanel_login_password"
            size="small"
          />
          <TextField
            label="URL service"
            fullWidth
            variant="outlined"
            value={formData?.url_service}
            onChange={(e) => handleChange("url_service", e.target.value)}
            name="url_service"
            type="text"
            size="small"
          />
        </>
      {/*)}*/}

      {/* API Fields */}
      {formData.reading_type === "API" && (
        <>
          <TextField
            label="API Key"
            fullWidth
            variant="outlined"
            value={formData?.smmpanel_api_key}
            onChange={(e) => handleChange("smmpanel_api_key", e.target.value)}
            name="smmpanel_api_key"
            size="small"
          />
          <TextField
            label="Api Url"
            fullWidth
            variant="outlined"
            value={formData?.smmpanel_api_url}
            onChange={(e) => handleChange("smmpanel_api_url", e.target.value)}
            name="smmpanel_api_url"
            size="small"
          />
        </>
      )}
      <div className="griddy-data">
        <TextField
          label="Ticket number"
          fullWidth
          variant="outlined"
          onChange={(e) => {
            handleChange("smmpanel_ticket_numper", e.target.value);
          }}
          name="smmpanel_ticket_numper"
          value={formData?.smmpanel_ticket_numper}
          size="small"
        />
        <LocalizationProvider dateAdapter={AdapterDayjs} className="w-full">
          <DatePicker
            label="Date of ticket"
            value={
              formData?.smmpanel_date_of_ticket
                ? dayjs(formData.smmpanel_date_of_ticket) // Convert string to Day.js object
                : null // Handle null values
            }
            name="smmpanel_date_of_ticket"
            className="w-full"
            onChange={(newValue) => {
              // Format the date to "YYYY-MM-DD" using dayjs
              const formattedDate = newValue
                ? newValue.format("YYYY-MM-DD")
                : null;
              handleChange("smmpanel_date_of_ticket", formattedDate);
            }}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
        <Autocomplete
          disablePortal
          options={countries}
          getOptionLabel={(option) => option.name || ""}
          value={
            countries.find((country) => country.id === formData.country_id) ||
            null
          }
          onChange={handleCoursesChange}
          renderInput={(params) => (
            <TextField {...params} label="Countries" variant="outlined" />
          )}
          size="small"
        />

          <Autocomplete
              disablePortal
              options={currencies}
              value={formData.currency || "USD"}
              onChange={(event, newValue) => {
                  handleChange("currency", newValue);
              }}
              renderInput={(params) => (
                  <TextField
                      {...params}
                      label="Currency"
                      variant="outlined"
                      size="small"
                      required
                  />
              )}
          />

        <FormControl fullWidth size="small">
          <InputLabel>Type</InputLabel>
          <Select
            value={formData?.type || "P"}
            label="Type"
            onChange={(e) => handleChange("type", e.target.value)}
          >
            <MenuItem value="S">Reseller</MenuItem>
            <MenuItem value="P">Provider</MenuItem>
            <MenuItem value="SP">Reseller & Provider</MenuItem>
          </Select>
        </FormControl>
          <TextField
              label="Order"
              fullWidth
              variant="outlined"
              onChange={(e) => {
                  handleChange("order", e.target.value);
              }}
              name="order"
              value={formData?.order}
              size="small"
          />
      </div>



      <TextField
        fullWidth
        variant="outlined"
        multiline
        label="Description"
        rows={5}
        onChange={(e) => {
          handleChange("description", e.target.value);
        }}
        name="description"
        value={formData?.description}
      />
      <TextField
        fullWidth
        variant="outlined"
        multiline
        label="Smmpanel notice"
        rows={5}
        onChange={(e) => {
          handleChange("smmpanel_notice", e.target.value);
        }}
        name="smmpanel_notice"
        value={formData?.smmpanel_notice}
      />
    </div>
  );
};

export default MainDetails;
